import "./lib/toastOverride"; // Must be first — replaces blocking alert() with toast

// Served under a path prefix in production (PUBLIC_URL=/new behind the
// sms.combirds.com rewrite). If opened WITHOUT the prefix (old
// smsnew2.combirds.com bookmarks like /sms), hop to the prefixed URL so the
// router (basename = PUBLIC_URL) can take over.
if (process.env.PUBLIC_URL &&
    !window.location.pathname.startsWith(process.env.PUBLIC_URL)) {
  window.location.replace(
    process.env.PUBLIC_URL + window.location.pathname +
    window.location.search + window.location.hash,
  );
}
// Bare prefix without a trailing slash (sms.combirds.com/new) — normalize to
// /new/ so the router's '/' route loads (login → role-aware redirect into
// the app) instead of depending on server-rewrite trailing-slash behavior.
if (process.env.PUBLIC_URL &&
    window.location.pathname === process.env.PUBLIC_URL) {
  window.location.replace(
    process.env.PUBLIC_URL + '/' +
    window.location.search + window.location.hash,
  );
}
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import "babel-polyfill";
// import logger from 'dev/logger';

import rootReducer from "./reducers";

import App from "./views/App";

import "./static/scss/app.scss";

const isProduction = process.env.NODE_ENV === "production";

let store = null;

if (isProduction) {
  // In production adding only thunk middleware
  const middleware = applyMiddleware(thunk);

  store = createStore(rootReducer, middleware);
} else {
  // In development mode beside thunk
  // logger and DevTools are added
  const middleware = applyMiddleware(thunk);
  let enhancer;

  // Enable DevTools if browser extension is installed
  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    // eslint-disable-line
    enhancer = compose(
      middleware,
      window.__REDUX_DEVTOOLS_EXTENSION__(), // eslint-disable-line
    );
  } else {
    enhancer = compose(middleware);
  }

  store = createStore(rootReducer, enhancer);
}

// React 18: createRoot replaces the ReactDOM.render entry point.
// StrictMode kept off here to avoid the double-effect dev behaviour
// breaking existing class-component lifecycle assumptions; can be
// enabled later as a separate hardening pass.
const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// If you want to   start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
